/**
 * St John Inventory Logic (Headless)
 * Acts as a state machine. Updates attributes, leaves DOM rendering to CSS.
 * * Output Attributes:
 * - data-ui-state: "available" | "low" | "out" | "backorder"
 * - data-qty: "5"
 * - data-policy: "deny" | "continue"
 */
if (!customElements.get("inventory-logic")) {
  class InventoryLogic extends HTMLElement {
    static get observedAttributes() {
      return ["data-id", "data-qty", "data-policy", "data-management"];
    }

    constructor() {
      super();
      this.threshold = parseInt(this.dataset.threshold) || 10;
    }

    connectedCallback() {
      // 1. Load Map (for dynamic switching)
      if (this.dataset.inventoryMap) {
        try {
          this.variants = JSON.parse(this.dataset.inventoryMap);
        } catch (e) {
          console.warn("Inventory: Bad Map", e);
        }
      }

      // 2. Listen for Variant Changes
      if (this.dataset.listen === "true") {
        this.unsubscribe = FoxTheme.pubsub.subscribe(
          FoxTheme.pubsub.PUB_SUB_EVENTS.variantChange,
          this.onVariantChange.bind(this)
        );
      }

      // 3. Initial Logic Run
      this.refreshState();
    }

    disconnectedCallback() {
      if (this.unsubscribe) this.unsubscribe();
    }

    // React to attribute changes (allows external scripts to control it)
    attributeChangedCallback(name, oldValue, newValue) {
      if (oldValue !== newValue) {
        if (name === "data-id" && this.variants) {
          this.updateFromMap(newValue);
        } else {
          this.refreshState();
        }
      }
    }

    onVariantChange(event) {
      if (event.data.sectionId === this.dataset.sectionId) {
        this.setAttribute("data-id", event.data.variant.id);
      }
    }

    updateFromMap(variantId) {
      const variant = this.variants?.find((v) => v.id == variantId);
      if (variant) {
        // We simply mirror the variant data to DOM attributes
        // This triggers attributeChangedCallback -> refreshState()
        this.dataset.qty = variant.qty;
        this.dataset.policy = variant.policy;
        this.dataset.management = variant.management;
      }
    }

    refreshState() {
      const qty = parseInt(this.dataset.qty) || 0;
      const policy = this.dataset.policy || "deny";
      const management = this.dataset.management || "shopify";

      let uiState = "available";

      if (management === "shopify") {
        if (qty > 0) {
          if (qty <= this.threshold) {
            uiState = "low";
          } else {
            uiState = "available";
          }
        } else {
          // Qty is 0 or less
          if (policy === "continue") {
            uiState = "backorder";
          } else {
            uiState = "out";
          }
        }
      } else {
        // Not tracked -> Always available
        uiState = "available";
      }

      // OUTPUT: Write the state to the DOM
      this.setAttribute("data-ui-state", uiState);
    }
  }
  customElements.define("inventory-logic", InventoryLogic);
}
